<template>
  <div v-editable="blok" class="testimonial">
    <div class="testimonial__author-image-wrapper">
      <BaseNuxtImage
        v-if="blok.image?.filename"
        class="testimonial__author-image"
        :src="blok.image.filename"
        :alt="blok.image.alt || `Portrait of ${blok.author}`"
      />
    </div>
    <div class="testimonial__content">
      <img
        width="24"
        height="24"
        class="testimonial__quote-icon"
        src="@/assets/icons/24-quote-xl.svg?url"
        alt="Quote Icon"
      />
      <StoryblokComponent
        v-for="childBlok in blok.quote"
        :key="childBlok._uid"
        class="testimonial__quote"
        :blok="childBlok"
      />
      <div class="testimonial__author-details">
        <p class="testimonial__author-name">
          {{ blok.author }}
        </p>
        <StoryblokComponent
          v-for="childBlok in blok.role"
          :key="childBlok._uid"
          class="testimonial__author-role"
          :blok="childBlok"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbTestimonialStoryblok } from '@/types'
interface Props {
  blok: SbTestimonialStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.testimonial {
  display: flex;
  flex-wrap: wrap;
  color: var(--cobalt-800);
  font-size: var(--font-size-paragraph-s);

  @media (min-width: $breakpoint-md) {
    flex-wrap: nowrap;
  }

  &__author-image-wrapper {
    margin-right: 40px;
  }

  &__author-image {
    width: 148px;
    height: 148px;
    border-radius: 50%;

    @media (min-width: $breakpoint-md) {
      width: 180px;
      height: 180px;
    }

    @media (min-width: $breakpoint-lg) {
      width: 300px;
      height: 300px;
    }
  }

  &__quote-icon {
    width: 24px;
    height: 24px;
    margin-top: 32px;

    @media (min-width: $breakpoint-md) {
      margin-top: 0;
    }
  }

  &__quote {
    margin: 8px 0 24px;
    letter-spacing: var(--letter-spacing-paragraph-s);
    line-height: 24px;
    font-size: var(--font-size-paragraph-s);

    @media (min-width: $breakpoint-md) {
      margin: 16px 0 24px;
      font-size: var(--font-size-paragraph-m);
      letter-spacing: var(--letter-spacing-paragraph-m);
      line-height: 30px;
    }
  }

  &__author-name {
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-paragraph-m);
    letter-spacing: var(--letter-spacing-paragraph-m-bold);
    line-height: 30px;
    margin: 0;

    @media (min-width: $breakpoint-md) {
      font-size: var(--font-size-paragraph-l);
      letter-spacing: var(--letter-spacing-paragraph-l-bold);
      line-height: 38px;
    }
  }

  &__author-role {
    font-size: var(--font-size-paragraph-s);
    line-height: 26px;
    margin: 0;
    letter-spacing: 0;

    @media (min-width: $breakpoint-md) {
      font-size: var(--font-size-paragraph-m);
      letter-spacing: var(--letter-spacing-paragraph-m);
      line-height: 30px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
